import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json'
import Utilis from '../../../Models/Utilis';
import DistantProfils from '../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import { Box, Typography, styled } from '@mui/material';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import DataTypeTable from '../../../Types/DataTypeTable';
import Datas from "../../../Data/Data.json";
import { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import Garantie from '../../../Models/Garantie';
import formatOrderDate from '../../../Functions/Traitement/formatOrderDate';


const columns: ColumnsType<DataTypeTable> = [
  {
    title: 'Code Garantie',
    dataIndex: 'codgar',
  },
  {
    title: 'N° Identification',
    dataIndex: 'NUMIDENTI',
  },
  {
    title: 'Type Garantie',
    dataIndex: 'codgar',
  },
  {
    title: 'Localisation',
    dataIndex: 'LOCAL',
  },
  {
    title: 'Désignation',
    dataIndex: 'DESIGNATION',
  },
  {
    title: 'Date Début',
    dataIndex: 'DATDEB',
  },
  {
    title: 'Date Fin',
    dataIndex: 'DATFIN',
  },
  {
    title: 'Commentaire',
    dataIndex: 'TEXTCOMMEN',
  },
  {
    title: 'Valeur Garantie',
    dataIndex: 'VALGARANTI',
  },
  {
    title: 'Valeur Disponible',
    dataIndex: 'dispo',
  }
  ,
  {
    title: 'Status garantie',
    dataIndex: 'CDETAT',
  }
];



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const ValidationGarantie = (props: {isButton?: true}) => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const navigate = useNavigate()

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")

  const [Data, SetData] = useState<DataTypeTable[]>([]);
  const [scroll, setScrool] = useState<any>({ y: 250, x: 10 })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));

  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setSelectedRowKeys([])
        //localStorage.clear()
      }
    }
    catch (error) {
      console.log(error)
    }
  }, 1);


  const onSelectChange = (newSelectedRowKeys: any) => {

    console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);
    form.setFieldsValue(Data[newSelectedRowKeys])

    setSelectedRowKeys(newSelectedRowKeys);

    if(Data[newSelectedRowKeys].dispo?.toString() != Data[newSelectedRowKeys].VALGARANTI){
      setModifActve(true)
      SweetAlert.fire({ title: "Garantie non modifiable. Déjà utilisé", icon: "warning" })
    }else{
      setModifActve(false)
    }
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    setModifActve(true)
    form.resetFields()
    form.setFieldValue("niveau", 900)
    localStorage.setItem(Datas.LocalVariable.reset, "0")
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
    setModifActve(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Datas.LocalVariable.reset, "1")
    SetData([])
    //localStorage.setItem(Datas.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    setAnnulActive(false)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Validation garantie
        </span>
      ),
      children: <Tab1 form={form} disabled={ajoutActve} />,
    }
  ];

  const onFinish = (values: any) => {
  
    let DATDEB = form.getFieldValue('DATDEB') //formatDate(values.DATDEB)
    let DATFIN = form.getFieldValue('DATFIN')//formatDate(values.DATFIN)
    

    if (form.getFieldValue('CDETAT')!=='' || form.getFieldValue('CDETAT') ===null) {
      if (sbmit == "add") {
        SweetAlert.fire({
          title: "Validation de la garantie",
          text: "Voulez-vous valider cette garantie " + values.NUMIDENTI + " ?",
          showCancelButton: true,
          color: "green",
          confirmButtonText: "Yes",
          confirmButtonColor: "green",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)
            //let group = profilsDistant.find(()=>)
  
            values = { "codage": user.codage, ...values }
            console.log(values)
            let garantie : Garantie = values
            garantie.DATDEB = formatDate(garantie.DATDEB)
            garantie.DATFIN = formatDate(garantie.DATFIN)
  
  
            //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(garantie)));
  
            let data = Crypter.encrypt(JSON.stringify(garantie));
  
            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: Datas.ApiUrl.CreateGarantie,
              headers: {
                //'CypherGarantie': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: data
            };
  
            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                  if (res.StatutCode == 200) {
                    form.resetFields()
                    localStorage.clear()
                    setIsSubmit(false)
                    SweetAlert.fire({ title: res.Message, icon: "success" })
  
                    localStorage.clear()
                    initialiazeButton()
                    setSbmit("")
                    SetData([])
                  }
                  else {
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
              });
  
          }
        })
      }
      else if (sbmit == "update") {
        SweetAlert.fire({
          title: "Validation de la garantie",
          text: "Voulez-vous valider cette garantie " + values.codgar + " ?",
          showCancelButton: true,
          color: "green",
          confirmButtonText: "Yes",
          confirmButtonColor: "green",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)
            //let group = profilsDistant.find(()=>)
      
            values = { "codage": user.codage, ...values }
             alert(values)
            let garantie : Garantie = values
           // garantie.DATDEB = formatDate(garantie.DATDEB)
            //garantie.DATFIN = formatDate(garantie.DATFIN)
             garantie.DATDEB = form.getFieldValue('DATDEB') //formatDate(values.DATDEB)
             garantie.DATFIN = form.getFieldValue('DATFIN')//formatDate(values.DATFIN)
  
             garantie.UTIVAL = user.coduti
              garantie.DATVAL = new Date(formatDate(user.datjour)) 
              garantie.CdEtat = "02"
  
            //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(garantie)));
  
            let data = Crypter.encrypt(JSON.stringify(garantie));
  
            let config = {
              method: 'put',
              maxBodyLength: Infinity,
              url: Datas.ApiUrl.ValidateGarantie,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: data
            };
  
            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                  if (res.StatutCode == 200) {
                    //let code = values.NUMIDENTI
                    form.resetFields()
                    localStorage.clear()
                    setIsSubmit(false)
                    SweetAlert.fire({ title: res.Message, icon: "success" })
  
                    localStorage.clear()
                    initialiazeButton()
                    setSbmit("")
                    SetData([])
                  }
                  else {
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
              });
  
          }
        })
      }
      else if (sbmit == "validate") {
        SweetAlert.fire({
          title: "Validation de la garantie",
          text: "Voulez-vous valider cette garantie " + values.codgar + " ?",
          showCancelButton: true,
          color: "green",
          confirmButtonText: "Yes",
          confirmButtonColor: "green",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)
            //let group = profilsDistant.find(()=>)
      
            values = { "codage": user.codage, ...values }
             alert(values)
            let garantie : Garantie = values
           // garantie.DATDEB = formatDate(garantie.DATDEB)
            //garantie.DATFIN = formatDate(garantie.DATFIN)
             garantie.DATDEB = form.getFieldValue('DATDEB') //formatDate(values.DATDEB)
             garantie.DATFIN = form.getFieldValue('DATFIN')//formatDate(values.DATFIN)
  
             garantie.UTIVAL = user.coduti
              garantie.DATVAL = new Date(formatDate(user.datjour)) 
              garantie.CdEtat = "03"
  
            //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(garantie)));
  
            let data = Crypter.encrypt(JSON.stringify(garantie));
  
            let config = {
              method: 'put',
              maxBodyLength: Infinity,
              url: Datas.ApiUrl.ValidateGarantie,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: data
            };
  
            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                  if (res.StatutCode == 200) {
                    //let code = values.NUMIDENTI
                    form.resetFields()
                    localStorage.clear()
                    setIsSubmit(false)
                    SweetAlert.fire({ title: res.Message, icon: "success" })
  
                    localStorage.clear()
                    initialiazeButton()
                    setSbmit("")
                    SetData([])
                  }
                  else {
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
              });
  
          }
        })
      }
    }else{
      SweetAlert.fire({ title: "Cette garantie a déjà fait l'objet d'une validation ou invalidation", text: "["+formatOrderDate(values.codgar)+", "+formatOrderDate(values.lib_NUMCLI)+"] incorrect", icon: "warning" })
    }

  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {
    let numidentity = form.getFieldValue("codgar")
    let numcli = form.getFieldValue("NUMCLI")
    let libelle = form.getFieldValue("lib_codgar")

    SetData([])

    if ((numidentity == undefined && numcli == undefined) || (numidentity == '' && numcli == '') || (numidentity == '' && numcli == undefined) || (numidentity == undefined && numcli == '')) {
      SweetAlert.fire({
        title: "Warning",
        text: "Enter search element",
        icon: 'warning'
      })
      return;
    }
    let data = (numidentity != undefined && numidentity != '') ? Crypter.encrypt(JSON.stringify(numidentity + Datas.LocalVariable.separator + "ID")) : Crypter.encrypt(JSON.stringify(numcli + Datas.LocalVariable.separator + "CL"));
    console.log(data)
    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetGarantie,
        headers: {
          'CypherSearch': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              const datat: DataTypeTable[] = [];
              console.log(res)
              //alert(JSON.stringify(res))
              var garantie : Garantie = res.Result.Table[0];
              garantie.DATDEB = ReformatDate(garantie.DATDEB)
              garantie.DATFIN = ReformatDate(garantie.DATFIN)
              form.setFieldsValue(garantie)
              form.setFieldValue('lib_codgar', form.getFieldValue("DESIGNATION"))

              let garanties = res.Result.Table1;

              if (garanties.length === 0) {
                //console.log("aucun élément ");
                SetData([])
              }
              else {
                garanties.map((data: any, indice: number) => {
                  //console.log(JSON.stringify(data))
                  datat.push({
                    key: indice,
                    NUMIDENTI: data.NUMIDENTI,
                    NUMCLI: data.NUMCLI,
                    lib_NUMCLI: data.lib_NUMCLI,
                    codgar: data.codgar,
                    lib_codgar: data.lib_codgar,
                    LOCAL: data.LOCAL,
                    VALGARANTI: data.VALGARANTI,
                    DESIGNATION: data.DESIGNATION,
                    DATDEB: ReformatDate(data.DATDEB),
                    DATFIN: ReformatDate(data.DATFIN),
                    TEXTCOMMEN: data.TEXTCOMMEN,
                    fichier: data.fichier,
                    valCouvert: data.valCouvert,
                    dispo: data.dispo,
                    UTILIS: data.UTILIS,
                    DATCRE: data.DATCRE,
                    UTIVAL: data.UTIVAL,
                    DATVAL: data.DATVAL,
                    CDETAT: data.CDETAT
                  });
                  SetData(datat);
                })
              }


              

              localStorage.clear()
              initialiazeButton()

              cunsultButton()
              setImpActive(false)

              if(garantie.dispo?.toString() != garantie.VALGARANTI.toString()){
                setModifActve(true)
                SweetAlert.fire({ title: "Garantie non modifiable. Déjà utilisé", icon: "warning" })
              }else{
                setModifActve(false)
              }

            }
            else {
              form.setFieldValue("codgar", numidentity)
              form.setFieldValue("NUMCLI", numcli)
              form.setFieldValue("lib_codgar", libelle)
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          form.setFieldValue("codgar", numidentity)
          form.setFieldValue("lib_codgar", libelle)
          form.setFieldValue("NUMCLI", numcli)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }

  }
  function modif() {
    modifButton()

  }

  function PrintGar() {
    try {
      localStorage.setItem(Datas.LocalVariable.tabGarantie, JSON.stringify({ "columns": columns, "data": Data, "form": undefined }))
      navigate("/garranty/print")
    } catch (error) {
      SweetAlert.fire({
        title: "Warning",
        text: JSON.stringify(error),
        icon: "warning"
      })
    }
  }


  return (
    <div className={props.isButton? 'tab100': 'tab'}>
      <Typography align='center' className='formTitle'><b>{window.location.pathname} </b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                {/* <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button> */}
                {/* <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button> */}
                <Button size='large' className='bt_add' disabled={consulActive} onClick={() => {onFinish("any") ;setSbmit('update')}}  type="ghost" htmlType="submit" block>
                  Valider
                </Button>
                {/* <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button> */}
                <Button size='large'  className='bt_add' onClick={() => {onFinish("any") ;setSbmit('validate')}} disabled={consulActive} type="ghost" htmlType="submit" block  >
                  Rejeter
                </Button>
                {/* <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button> */}
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} /> <br /><br />
              <Box  display={"flex"} fontStyle="inherit" className='border-left tabElement'  sx={{  p: 2,my:5 }}>
                <Spin spinning={loading}>
                  <Form disabled={!enregActve}>
                    <Table size='small' style={{ width: '100%' }} rowSelection={{ ...rowSelection, type: "radio" }} columns={columns} dataSource={Data} scroll={{ y: 250, x: 10 }} pagination={{ defaultPageSize: 10, position: ["bottomRight"] }} />
                  </Form>
                  </Spin>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default ValidationGarantie;